<template>
    <card class="radar-card">
        <div slot="header">
            <h3>{{ $t('common.competencies') }}</h3>
        </div>

        <div class="chart">
            <Radar
                :chart-options="chartOptions"
                :chart-data="chartData"
                chart-id="radar-chart"
                dataset-id-key="label"
                :plugins="[]"
                :css-classes="''"
                :styles="{}"
                :width="400"
                :height="400"
            />
        </div>

    </card>
</template>

<script>
    import { Radar } from 'vue-chartjs/legacy'

    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        PointElement,
        LineElement,
        RadialLinearScale
    } from 'chart.js'

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        PointElement,
        RadialLinearScale,
        LineElement
    )

    export default {

        components: {
            Radar,
        },

        props: {
            evaluation: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        r: {
                            beginAtZero: true,
                            max: 6,
                        }
                    },
                    plugins: {
                        legend: {
                            display: false,
                        }
                    }
                }
            }
        },

        computed: {

            chartData() {
                return {
                    labels: Object.values(this.evaluation).map(comp => comp.name),
                    datasets: [
                        {
                            borderColor: '#32325d',
                            borderWidth: 1,
                            pointRadius: 8,
                            pointBackgroundColor: Object.values(this.evaluation).map(comp => this.pointColor(comp)),
                            pointBorderColor: '#fff',
                            data: Object.values(this.evaluation).map(comp => comp.avg)
                        },
                    ]
                }
            },
        },

        methods: {

            pointColor(item) {
                if (!item.avg) {
                    return '#B4C2CC'
                }
                if (item.gonogo == 'go') {
                    return '#2DCE89'
                }
                return '#F5365C'
            }
        }
    }
</script>
